import { Controller, useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, TextField, MenuItem, Typography, Box } from "@material-ui/core";
import { Alert } from '@material-ui/lab';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { invokePostService, invokeGetService, setReRender, handleSnackBar, handleMultiLineSnackBar } from "../../../store/global/actions";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js";

export const RemapClusterlets = ({ onClose, selectedTransaction }) => {
    const { handleSubmit, control } = useForm();

    const dispatch = useDispatch();

    const [isFetching, setIsFetching] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [clusterletsInTransaction, setClusterletsInTransaction] = useState([]);
    const [allClusterlets, setAllClusterlets] = useState([]);
    const [allDelegates, setAllDelegates] = useState([]);


    const fetchTransactionClusterlets = () => {
        setIsFetching(true);
        dispatch(invokeGetService('getTransactionAssociates', [selectedTransaction]))
            .then((response) => {
                if (response.status === true) {
                    setClusterletsInTransaction(response?.data?.clusterlets);
                    setAllClusterlets(response?.data?.allClusterlets.filter(item => item.type === 2 || item.type === 3));
                    setAllDelegates(response?.data?.allClusterlets.filter(item => item.type === 1));
                }
                setIsFetching(false);
            });
    }
    useEffect(() => {
        fetchTransactionClusterlets()
    }, [])


    const onUpdate = (data) => {
        const remappedClusterlets = Object.fromEntries(Object.entries(data).filter(([key, value]) => key !== value));
        if (Object.keys(remappedClusterlets).length === 0) {
            dispatch(handleSnackBar({ open: true, message: "Nothing to update", severity: "error" }));
            return;
        }
        setIsUpdating(true);
        dispatch(invokePostService('remapClusterlets', { remappedClusterlets }, [selectedTransaction]))
            .then((response) => {
                if (response.status === true) {
                    dispatch(setReRender());
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                    onClose();
                } else {
                    if (response.message) {
                        dispatch(handleMultiLineSnackBar({ open: true, message: response.message, severity: "error" }));
                    }
                }
                setIsUpdating(false);
            });
    }

    return (
        <>
            <Grid container direction={"row"} spacing={1} id="remap_clusterlets_container">
                {isFetching && <Grid item xs={12}>
                    <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '9vh', marginBottom: '9vh' }} />
                </Grid>}

                {!isFetching && clusterletsInTransaction?.length === 0 &&
                    <Grid item xs={12}>
                        <Box p={2}>
                            <Alert severity="warning">
                                No clusterlets selected for the transaction
                            </Alert>
                        </Box>
                    </Grid>
                }
                {!isFetching &&
                    clusterletsInTransaction?.map((clusterlet) => (
                        <>
                            <Grid item xs={6} key={`label_${clusterlet._id}`}>
                                <label htmlFor={`clusterlet-${clusterlet._id}`}>{clusterlet.name}</label>
                            </Grid>
                            <Grid item xs={6} key={clusterlet._id}>
                                <Controller
                                    name={clusterlet._id}
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={clusterlet._id}
                                    render={({ field, onChange }) => (
                                        <TextField
                                            {...field}
                                            name={clusterlet._id}
                                            id={clusterlet.name}
                                            select
                                            fullWidth
                                            defaultValue={clusterlet._id}
                                            variant="outlined"
                                            onChange={e => { onChange(e) }}
                                        >
                                            {clusterlet.type === 1 ? allDelegates.map((option) => (
                                                <MenuItem key={option._id} value={option._id}>
                                                    {option.name}
                                                </MenuItem>
                                            )) : allClusterlets.map((option) => (
                                                <MenuItem key={option._id} value={option._id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                            </Grid>

                        </>
                    ))
                }
            </Grid>

            {clusterletsInTransaction?.length !== 0  &&
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <UpdateCancel updateDisable={isFetching || isUpdating} onUpdate={handleSubmit(onUpdate)} onCancel={onClose} content={isUpdating ? "Updating.." : "Update"} />
            </Grid>
            }
        </>
    )

}